export type ContactGroupType = 'Email' | 'Telephone' | 'Other' | "DataBox";

export const ContactGroupType = {
  Email: 'Email' as ContactGroupType,
  Telephone: 'Telephone' as ContactGroupType,
  Other: 'Other' as ContactGroupType,
  DataBox: 'DataBox' as ContactGroupType
};